module.exports = __webpack_public_path__ + "img/038-storm-6.f3c2845e.svg";